/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import SubscriptionField from "./features/subscriptionfield";

const AddSubscription = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <SubscriptionField />
        </section>
      </Layout>
    </>
  );
};
export default AddSubscription;
